"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.rag.name': '知识库',
    'tools.rag.description': '从知识库文档中搜索和检索相关信息',
};
